import { Type } from 'class-transformer';
import { CountdownConfig } from 'ngx-countdown';

export class Client {
    name!: string;
    telephoneNumber!: string;
    email!: string;
    notas!: any[];
    street!: string;
    streetNr!: string;
    bus?: string;
    zipCode!: string;
    city!: string;
    lat!: string;
    lng!: string;
    distanceInKm!: number;
    travelTimeInMinutes!: string;
    oneTimeExtraInfo?: string;
    extraInfo?: string;
    internalInfo?: string;

    public getAddress(): string {
        return `${this.street} ${this.streetNr}${this.bus ? ` Bus: ${this.bus}` : ''}, ${this.city}`;
    }
}

export class OrderLine {
    count!: string;
    article!: string;
    size!: string;
    price!: string;
}

export class OrderDetail {
    publicReference!: string;
    orderLines!: OrderLine[];
    totalPrice!: string;
    @Type(() => Date)
    placedAt!: Date;
    paymentType!: PaymentMethod;
    paymentComplete!: boolean;
    @Type(() => Date)
    timedOrderDate!: Date;
    timedOrder!: boolean;
    notas!: any[];
    isInDelivery!: boolean;
    isReadyForDelivery!: boolean;
    isFinished!: boolean;

    getAmountOfFridgeLines(): number {
        const fridgeSizes = ["33CL", "66ML", "3X66ML", "1L"]
        const fridgeOrderLines = this.orderLines.filter(line => fridgeSizes.includes(line.size));
        return fridgeOrderLines.reduce((sum, line) => sum + parseInt(line.count), 0);
    }
}

export class Order {
    id!: string;
    @Type(() => Client)
    client!: Client;
    @Type(() => OrderDetail)
    order!: OrderDetail;

    getCountdownConfig(): CountdownConfig | null {
        if (!this.order.timedOrder) return null;
        return {
            stopTime: this.order.timedOrderDate.getTime()
        }
    }
}

export class ExtraInfo {
    orderId!: string;
    internalInfo?: string;
    extraInfo?: string;
    oneTimeExtraInfo?: string;
}

export enum PaymentMethod {
    Cash = 'Cash',
    Card = 'Bancontact',
    QrCode = 'Payconiq',
    Transfer = 'Overschrijving',
    QR = 'QR Code',
}
